(function(window) { var svs = window.svs || {}; svs.modules = svs.modules || []; if(svs.modules.indexOf('/components/numbergames/pay-numbergames/assets/javascripts/make-payment.js') >= 0) return;  svs.modules.push('/components/numbergames/pay-numbergames/assets/javascripts/make-payment.js');

'use strict';

const _svs$numbergames = svs.numbergames,
  _svs$numbergames$camp = _svs$numbergames.campaign,
  openCampaignApi = _svs$numbergames$camp.openCampaignApi,
  asyncOpenCampaignApi = _svs$numbergames$camp.asyncOpenCampaignApi,
  productMapping = _svs$numbergames.productMapping;
const _svs$tur$pay = svs.tur.pay,
  accountServices = _svs$tur$pay.account_services,
  apiCalls = _svs$tur$pay.api_calls,
  communication = _svs$tur$pay.communication,
  dialogs = _svs$tur$pay.dialogs,
  misc = _svs$tur$pay.misc,
  utils = _svs$tur$pay.utils;
const _svs$numbergames$pay_ = svs.numbergames.pay_numbergames,
  ifIsProlongation = _svs$numbergames$pay_.ifIsProlongation,
  verifyActiveAccount = _svs$numbergames$pay_.verifyActiveAccount,
  updateAccountBalance = _svs$numbergames$pay_.updateAccountBalance,
  checkSyndicateTerms = _svs$numbergames$pay_.checkSyndicateTerms,
  updateDraws = _svs$numbergames$pay_.updateDraws,
  ifHasClosedJokerDraws = _svs$numbergames$pay_.ifHasClosedJokerDraws,
  closedJokerDrawDialog = _svs$numbergames$pay_.closedJokerDrawDialog,
  removeClosedJoker = _svs$numbergames$pay_.removeClosedJoker,
  ifDrawOpenIsToday = _svs$numbergames$pay_.ifDrawOpenIsToday,
  playNextDrawDialog = _svs$numbergames$pay_.playNextDrawDialog,
  addDataToWagers = _svs$numbergames$pay_.addDataToWagers,
  confirmPaymentTitle = _svs$numbergames$pay_.confirmPaymentTitle,
  confirmPaymentMessages = _svs$numbergames$pay_.confirmPaymentMessages,
  handlePayResponse = _svs$numbergames$pay_.handlePayResponse,
  ifDrawHasClosed = _svs$numbergames$pay_.ifDrawHasClosed,
  ifHasIncompleteWagers = _svs$numbergames$pay_.ifHasIncompleteWagers,
  trackPayment = _svs$numbergames$pay_.trackPayment;
async function numberOfChances(_ref) {
  let next = _ref.next,
    product = _ref.product,
    successfulWagers = _ref.successfulWagers;
  await asyncOpenCampaignApi.getCampaign(product);
  const chances = successfulWagers.reduce((chances, _ref2) => {
    var _wager$bets$find, _wager$bets;
    let wager = _ref2.wager;
    const bet = (_wager$bets$find = (_wager$bets = wager.bets).find) === null || _wager$bets$find === void 0 ? void 0 : _wager$bets$find.call(_wager$bets, bet => !productMapping.isJoker(bet.productId));
    return chances + openCampaignApi.calculateChances(product, {
      wager,
      draw: bet
    });
  }, 0);
  return next({
    chances
  });
}
function calculateActualPaidPrice(_ref3) {
  let next = _ref3.next,
    successfulWagers = _ref3.successfulWagers,
    successfulTickets = _ref3.successfulTickets;
  const wagersPrice = (sum, _ref4) => {
    let wagerAmounts = _ref4.wagerAmounts;
    return sum + svs.utils.format.CurrencyFromJupiterString(wagerAmounts.betAmount);
  };
  const ticketsPrice = (sum, _ref5) => {
    let price = _ref5.price;
    return sum + price;
  };
  next({
    actualPaidPrice: successfulWagers.reduce(wagersPrice, 0) + successfulTickets.reduce(ticketsPrice, 0)
  });
}
function removeWageridQuery(_ref6) {
  let next = _ref6.next;
  svs.utils.paramHandler.remove({
    key: 'wagerid'
  });
  next();
}
async function saveProlongedWagerIdToLocalStorage(_ref7) {
  let wagerId = _ref7.wagerId,
    product = _ref7.product,
    next = _ref7.next;
  await svs.tur.prolongStorage.set({
    wagerId,
    productId: product
  });
  next();
}

function isPayAfterDeposit() {
  const isPayAfterDeposit = svs.utils.paramHandler.get({
    key: 'afterpay'
  }).value;
  svs.utils.paramHandler.remove({
    key: 'afterpay'
  });
  return Boolean(isPayAfterDeposit);
}
function makePayment(_ref8) {
  let onDoneCb = _ref8.onDoneCb,
    onSuccessCb = _ref8.onSuccessCb,
    onCancelCallback = _ref8.onCancelCallback,
    saveState = _ref8.saveState,
    wagerData = _ref8.wagerData,
    ticketData = _ref8.ticketData,
    _ref8$showSuccessDial = _ref8.showSuccessDialog,
    showSuccessDialog = _ref8$showSuccessDial === void 0 ? true : _ref8$showSuccessDial;
  let product;
  let price;
  let drawCount;
  let wagers;
  let isSyndicate;
  let syndicate;
  let accountBalance;
  let draws;
  let regWagerResults;
  let closedWager;
  let incompleteWagers;
  let successfulWagers;
  let failedWagers;
  let grassrootsReceivers;
  let chances;
  let successfulTickets;
  let failedTickets;
  let actualPaidPrice;
  let lastDrawDate;
  let wagerId;
  const isAfterDeposit = isPayAfterDeposit();
  const isAutoPayAfterDeposit = svs.core.detect.feature('ft-numbergames-pay-after-deposit');
  if (wagerData) {
    product = wagerData.product;
    price = wagerData.price;
    drawCount = wagerData.drawCount;
    wagers = wagerData.wagers;
    lastDrawDate = wagerData.lastDrawDate;
    if (Array.isArray(ticketData)) {
      ticketData.forEach(ticket => {
        price += ticket.price;
      });
    } else if (ticketData) {
      price += ticketData.price;
    }
  }
  const calls = [{
    in: () => ({
      price,
      product,
      drawCount
    }),
    fn: accountServices.playerSession
  }, {
    fn: accountServices.playerSuspension
  }, {
    fn: accountServices.dayTimeLimit
  }, {
    fn: verifyActiveAccount,
    out: args => {
      var _args = args;
      isSyndicate = _args.isSyndicate;
      syndicate = _args.syndicate;
      return _args;
    }
  }, {
    in: () => ({
      isSyndicate
    }),
    fn: checkSyndicateTerms
  }, {
    in: () => ({
      price,
      product,
      isSyndicate,
      syndicate,
      isAutoPayAfterDeposit
    }),
    fn: accountServices.accountBalance,
    out: args => {
      var _args2 = args;
      accountBalance = _args2.accountBalance;
      return _args2;
    }
  }, function mainPaymentSequence(isRetry) {
    return {
      calls: [{
        in: () => ({
          wagers
        }),
        fn: updateDraws,
        out: args => {
          var _args3 = args;
          draws = _args3.draws;
          return _args3;
        }
      }, ifHasClosedJokerDraws({
        params: () => ({
          wagers,
          draws
        }),
        calls: _ref9 => {
          let productWithClosedJoker = _ref9.productWithClosedJoker;
          return [{
            in: () => ({
              productWithClosedJoker
            }),
            fn: closedJokerDrawDialog
          }, {
            in: () => ({
              wagers,
              price,
              productWithClosedJoker
            }),
            fn: removeClosedJoker,
            out: args => {
              var _args4 = args;
              wagers = _args4.wagers;
              price = _args4.price;
              return _args4;
            }
          }];
        }
      }), ifDrawOpenIsToday({
        params: () => ({
          wagers,
          draws,
          lastDrawDate
        }),
        calls: _ref0 => {
          let productOpenedToday = _ref0.productOpenedToday,
            regCloseTime = _ref0.regCloseTime;
          return [{
            in: () => ({
              product: productOpenedToday,
              regCloseTime,
              isSyndicate
            }),
            fn: playNextDrawDialog
          }];
        }
      }), {
        in: () => ({
          wagers,
          draws,
          isSyndicate,
          syndicate
        }),
        fn: addDataToWagers,
        out: args => {
          var _args5 = args;
          wagers = _args5.wagers;
          return _args5;
        }
      }, ...(isRetry || isAutoPayAfterDeposit && !isSyndicate && isAfterDeposit ? [] : [{
        in: () => ({
          accountBalance,
          isSyndicate,
          syndicate,
          price,
          title: confirmPaymentTitle({
            product,
            wagers,
            price,
            isSyndicate,
            ticket: ticketData
          }),
          messages: confirmPaymentMessages(wagers, product),
          product,
          isProlongation: new RegExp(/\/[a-z]+\/forlang-mina-spel\/[0-9]+/).test(window.location.pathname)
        }),
        fn: dialogs.confirmPayment
      }]), {
        in: () => ({
          wagers
        }),
        fn: apiCalls.payWagers,
        out: args => {
          var _args6 = args;
          regWagerResults = _args6.regWagerResults;
          return _args6;
        }
      }, {
        in: () => ({
          regWagerResults,
          wagers,
          successfulWagers,
          failedWagers
        }),
        fn: handlePayResponse,
        out: args => {
          var _args7 = args;
          closedWager = _args7.closedWager;
          incompleteWagers = _args7.incompleteWagers;
          successfulWagers = _args7.successfulWagers;
          failedWagers = _args7.failedWagers;
          return _args7;
        }
      }, ifDrawHasClosed({
        params: () => ({
          closedWager
        }),
        calls: () => [mainPaymentSequence.bind(null, true)]
      })]
    };
  }, function handleIncompleteWagers() {
    return {
      calls: [ifHasIncompleteWagers({
        params: () => ({
          incompleteWagers
        }),
        calls: () => [{
          in: () => ({
            wagers: incompleteWagers
          }),
          fn: apiCalls.payWagers,
          out: args => {
            var _args8 = args;
            regWagerResults = _args8.regWagerResults;
            return _args8;
          }
        }, {
          in: () => ({
            regWagerResults,
            wagers,
            successfulWagers,
            failedWagers
          }),
          fn: handlePayResponse,
          out: args => {
            var _args9 = args;
            incompleteWagers = _args9.incompleteWagers;
            successfulWagers = _args9.successfulWagers;
            failedWagers = _args9.failedWagers;
            return _args9;
          }
        }, handleIncompleteWagers]
      })]
    };
  }, {
    in: () => ({
      ticket: ticketData,
      channel: product
    }),
    fn: apiCalls.payTicket,
    out: args => {
      var _args0 = args;
      successfulTickets = _args0.successfulTickets;
      failedTickets = _args0.failedTickets;
      return _args0;
    }
  }, {
    in: () => ({
      successfulWagers,
      successfulTickets
    }),
    fn: calculateActualPaidPrice,
    out: args => {
      var _args1 = args;
      actualPaidPrice = _args1.actualPaidPrice;
      return _args1;
    }
  }, {
    in: () => ({
      accountBalance,
      actualPaidPrice,
      syndicate,
      isSyndicate
    }),
    fn: updateAccountBalance
  }, {
    fn: _ref1 => {
      let next = _ref1.next;
      utils.logPaymentResults({
        successfulTickets,
        failedTickets,
        successfulWagers,
        failedWagers
      });
      onSuccessCb === null || onSuccessCb === void 0 || onSuccessCb({
        successfulWagers
      });
      next();
    }
  }, ifIsProlongation({
    params: () => {
      var _wagerData$prolongedW;
      return {
        wagerId: (_wagerData$prolongedW = wagerData === null || wagerData === void 0 ? void 0 : wagerData.prolongedWagerId) !== null && _wagerData$prolongedW !== void 0 ? _wagerData$prolongedW : wagerId
      };
    },
    calls: () => [{
      in: () => {
        var _wagerData$prolongedW2;
        return {
          wagerId: (_wagerData$prolongedW2 = wagerData === null || wagerData === void 0 ? void 0 : wagerData.prolongedWagerId) !== null && _wagerData$prolongedW2 !== void 0 ? _wagerData$prolongedW2 : wagerId,
          product: wagerData.product
        };
      },
      fn: saveProlongedWagerIdToLocalStorage
    }, {
      fn: removeWageridQuery
    }]
  }), {
    in: () => ({
      product,
      successfulWagers,
      syndicate,
      isSyndicate
    }),
    fn: trackPayment
  }, ...(showSuccessDialog ? [{
    in: () => ({
      isSyndicate
    }),
    fn: misc.getGrassrootsReceivers,
    out: args => {
      var _args10 = args;
      grassrootsReceivers = _args10.grassrootsReceivers;
      return _args10;
    }
  }, {
    in: () => ({
      product,
      successfulWagers
    }),
    fn: numberOfChances,
    out: args => {
      var _args11 = args;
      chances = _args11.chances;
      return _args11;
    }
  }, {
    in: () => ({
      product,
      isSyndicate,
      successfulTickets,
      title: dialogs.getSuccessTitle({
        product,
        isSyndicate,
        failedWagers,
        successfulWagers,
        failedTickets
      }),
      messages: dialogs.getSuccessMessages({
        product,
        price: actualPaidPrice,
        isSyndicate,
        syndicate,
        grassrootsReceivers,
        chances,
        failedWagers,
        successfulTickets,
        failedTickets
      })
    }),
    fn: dialogs.paymentSuccess
  }] : []), {
    in: () => ({
      product: productMapping.getProductName(product)
    }),
    fn: communication.correctionEmail
  }, ifIsProlongation({
    params: () => ({
      wagerId
    }),
    calls: () => [{
      fn: svs.tur.pay.misc.showGrassrootsToaster
    }]
  })];
  svs.tur.pay.initPay({
    calls,
    cancel: () => {
      onCancelCallback === null || onCancelCallback === void 0 || onCancelCallback();
    },
    done: () => {
      var _successfulWagers, _failedWagers, _failedTickets;
      const wagerIds = !showSuccessDialog ? (_successfulWagers = successfulWagers) === null || _successfulWagers === void 0 ? void 0 : _successfulWagers.map(_ref10 => {
        let wagerClientSerial = _ref10.wagerClientSerial;
        return wagerClientSerial;
      }) : [];
      let partialPaymentFailed = false;
      if ((_failedWagers = failedWagers) !== null && _failedWagers !== void 0 && _failedWagers.length || (_failedTickets = failedTickets) !== null && _failedTickets !== void 0 && _failedTickets.length) {
        partialPaymentFailed = true;
      }
      onDoneCb === null || onDoneCb === void 0 || onDoneCb({
        price: actualPaidPrice,
        wagerIds,
        successfulTickets,
        partialPaymentFailed
      });
    },
    saveState
  });
}
svs.numbergames.pay_numbergames.makePayment = makePayment;

 })(window);